import { Stack } from '@mui/material';

import NotificationSettings from '@/features/NotificationSettings';
import PonduranceContactInfo from '@/features/PonduranceContactInfo';
import UserAuthKeys from '@/features/UserAuthKeys';
import UserInfo from '@/features/UserInfo';
import Header from '@/layout/Header/Header';
import MainContent from '@/layout/MainContent';

const UserAccount = () => {
  return (
    <>
      <Header title="User Account" />
      <MainContent>
        <Stack spacing={2}>
          <UserInfo />
          <NotificationSettings />
          <PonduranceContactInfo />
          <UserAuthKeys />
        </Stack>
      </MainContent>
    </>
  );
};

export default UserAccount;
